import { Observable, Subscription } from 'rxjs';

import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { formatDate } from '@angular/common';

import { AppConst } from '../../app-const';
import { EntranceExitEvent } from '../../firestore-models/entrance-exit-event';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-entrance-exit-entry-dialog',
  templateUrl: './select-entrance-exit-entry-dialog.component.html',
  styleUrls: ['./select-entrance-exit-entry-dialog.component.css'],
  standalone: false,
})
export class SelectEntranceExitEntryDialogComponent implements OnInit, OnDestroy {

  editForm : FormGroup;

  //各入退場管理エントリー情報に紐付くプロジェクトID
  projectId: string;
  //各入退場管理エントリー設備情報に紐付くプロジェクトの言語情報
  projectLanguages!: Array<ProjectLanguage>;

  private entranceExitEventsCollection!: AngularFirestoreCollection<EntranceExitEvent>;
  entranceExitEventsObservable!: Observable<EntranceExitEvent[]>;
  entranceExitEventsSubscribe!: Subscription;
  entranceExitEvents!: Array<EntranceExitEvent>;

  constructor(
    public dialogRef: MatDialogRef<SelectEntranceExitEntryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private configurationService: ConfigurationService,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.editForm = this.formBuilder.group({
      entrance_exit_event_id : new FormControl({value: data.entrance_exit_event_id, disabled: false }, []),
      entry_no: new FormControl({value: data.entry_no, disabled: false }, []),
    });
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;

    // 入退場管理イベント情報取得
    this.entranceExitEventsCollection = this.angularFirestore.collection<EntranceExitEvent>(
      AppConst.FIRESTORE_ENTRANCE_EXIT_EVENTS, ref => ref.where('project_id', '==', this.projectId));
    this.entranceExitEventsObservable = this.entranceExitEventsCollection.valueChanges({ idField: 'id' });
    this.entranceExitEventsSubscribe = this.entranceExitEventsObservable.subscribe(entranceExitEvents => {
      this.entranceExitEvents = entranceExitEvents.sort((a, b) => {
        if (a.open_start_date.seconds > b.open_start_date.seconds ) {
          return -1;
        }
        if (a.open_start_date.seconds < b.open_start_date.seconds ) {
          return 1;
        }
        return 0;
      });
    });
  }

  ngOnDestroy(): void {
    this.entranceExitEventsSubscribe.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  search(): void {
    const data = {
      entrance_exit_event_id: this.entrance_exit_event_id.value,
      entry_no: this.entry_no.value,
    }
    this.dialogRef.close(data);
  }

  //================================================================================================
  //  getter
  //================================================================================================
  get entrance_exit_event_id(): AbstractControl { return this.editForm.get('entrance_exit_event_id')!; }
  get entry_no(): AbstractControl { return this.editForm.get('entry_no')!; }
}
